import { ColorEnum } from '@/constants/color'
import { useRouterCanGoBackParamSubscriber } from '@/features/navigation/hooks/can-go-back'
import ShiftCloseoutContent from '@/features/shiftCloseouts/components/ShiftCloseoutContent'
import Provider from '@/features/shiftCloseouts/form/Provider'
import { useShiftCloseoutPreview } from '@/features/shiftCloseouts/hooks/useShiftCloseoutPreview'
import { useAppSelector } from '@/hooks/redux'
import { useScreenLayout } from '@/hooks/screen'
import { authSelectors } from '@/redux/reducers/auth/selectors'
import { FC } from 'react'
import { ActivityIndicator, StyleSheet, View } from 'react-native'
import invariant from 'tiny-invariant'

const NewShiftCloseoutPage: FC = () => {
    const layout = useScreenLayout()
    const profile = useAppSelector(authSelectors.currentProfile)
    const { loading, shiftCloseout } = useShiftCloseoutPreview()

    useRouterCanGoBackParamSubscriber()
    invariant(profile, 'Shift closeout requires an active profile')

    if (!shiftCloseout) {
        return (
            <View style={[styles.container, styles.loading]}>
                {loading && <ActivityIndicator />}
            </View>
        )
    }

    return (
        <View style={styles.container}>
            <Provider paymentMethods={shiftCloseout.paymentMethods}>
                <ShiftCloseoutContent
                    shiftCloseout={shiftCloseout}
                    layout={layout}
                    profileName={profile.name}
                />
            </Provider>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: ColorEnum.WHITE,
    },
    loading: {
        alignItems: 'center',
        justifyContent: 'center',
    },
})

export default NewShiftCloseoutPage
